export default "__VITE_ASSET__D$HTnPZf__"